import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};

  & > div.home-content {
    width: 100%;
    margin: 1rem auto 6rem auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: 100%;
    }
  }
`;

export const ContractsAndConstructionsHomeHeader = styled.header`
  display: flex;
  flex-direction: column;

  width: 97%;
  margin: 1rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto;
    max-width: ${({ theme }) => theme.breakpoints.laptopL};
    padding: 0;
  }

  & > .title {
    font-size: 1.625rem;
    font-weight: 700;
    margin-bottom: 1.25rem;
  }

  & > .subtitle {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const CustomersContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.875rem;
  border-bottom: 0.5rem solid ${({ theme }) => theme.colors.gray8};

  & > button {
    margin-top: 1.5rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: 9rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    flex-direction: row;
    align-items: flex-end;

    & > button {
      margin-left: 1.5rem;
      margin-top: 0;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 26rem;
  }
`;

export const ContractsAndConstructionsHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }
  margin-bottom: 0.5rem;
`;

export const CustomersFilterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  column-gap: 1rem;
  max-width: 41.375rem;
  margin-top: 1.5rem;

  & > div {
    width: 100%;
  }
`;
